export * from './config/types';
import type { Abi, Address } from 'viem';
import type { EvmFullFillCreateOrder } from '../api/types';

export enum EvmItemType {
    NATIVE,
    ERC20,
    ERC721,
    ERC1155,
    ERC721_WITH_CRITERIA,
    ERC1155_WITH_CRITERIA
}

export enum EvmOrderType {
    FULL_OPEN,
    PARTIAL_OPEN,
    FULL_RESTRICTED,
    PARTIAL_RESTRICTED,
    CONTRACT
}

export type EvmContractType = {
    address: Address;
    abi: Abi;
    chainId?: number;
    version?: string;
    name?: string;
};

export type EvmConsideration = {
    itemType: EvmItemType;
    token: Address;
    identifierOrCriteria: number | string;
    startAmount: number | string;
    endAmount: number | string;
    recipient: Address;
};

export type EvmOtherRecipientType = {
    token: Address;
    address: Address;
    value: number;
    itemType: EvmItemType;
};

type EvmABIInput = {
    internalType: string;
    name: string;
    type: string;
};

type EvmABIEntry = {
    inputs: EvmABIInput[];
    stateMutability: 'pure' | 'view' | 'nonpayable' | 'payable';
    type: 'function' | 'constructor' | 'event' | 'fallback';
};

type EvmArgs = (string | number | boolean | bigint)[];

type EvmFormattedArgs = Record<string, string | number | boolean | bigint>;

export type EvmChainError = {
    message: string;
    cause: string;
    details?: string;
    docsPath: string;
    metaMessages: string[];
    shortMessage: string;
    version: number;
    name: string;
    abi: EvmABIEntry[];
    args: EvmArgs[];
    contractAddress: string;
    formattedArgs: EvmFormattedArgs;
    functionName: string;
    sender: string;
};

export type EvmFullFillOrderType = {
    amount?: number;
} & EvmFullFillCreateOrder;
